import { useNationalDogSurveyContext } from "../../NationalDogSurvey/NationalDogSurvey.context";
import { dogProgress, dogProgressSit } from "../../NationalDogSurvey/fixtures";
import * as styles from "./NDSSurveyHeader.module.scss";

import Lottie from "lottie-light-react";
import React, { useMemo } from "react";

// const dogOwnerSectionMap: Partial<Record<NDS.RouteName, number>> = {
// 	ABOUT_YOUR_DOGS: 0,
// 	CHOOSING_YOUR_DOG: 1,
// 	UNDERSTANDING_YOUR_DOG: 2,
// 	RELATIONSHIP_WITH_YOUR_DOG: 3,
// 	ABOUT_YOU: 4,
// 	SUBSEQUENT_DOG: 4,
// };

// const nonDogOwnerSectionMap: Partial<Record<NDS.RouteName, number>> = {
// 	THOUGHTS_ON_DOGS: 0,
// 	ABOUT_YOU: 1,
// };

export const NDSSurveyHeaderProgressBar: React.FC = () => {
	const {
		surveyState: { surveyProgress },
	} = useNationalDogSurveyContext();

	const surveyProgressSegments: {
		routeName: NDS.RouteName;
		label: string;
		progress: number;
	}[] = useMemo(() => {
		return "THOUGHTS_ON_DOGS" in surveyProgress
			? [
					{
						routeName: "THOUGHTS_ON_DOGS",
						label: `Your progress for thoughts on dogs is ${surveyProgress.THOUGHTS_ON_DOGS}%`,
						progress: surveyProgress.THOUGHTS_ON_DOGS,
					},
					{
						routeName: "ABOUT_YOU",
						label: `Your progress for about you is ${surveyProgress.ABOUT_YOU}%`,
						progress: surveyProgress.ABOUT_YOU,
					},
				]
			: [
					{
						routeName: "ABOUT_YOUR_DOGS",
						label: `Your progress for About your dog is ${surveyProgress.ABOUT_YOUR_DOGS}`,
						progress: surveyProgress.ABOUT_YOUR_DOGS,
					},
					{
						routeName: "CHOOSING_YOUR_DOG",
						label: `Your progress for Choosing your dog is ${surveyProgress.CHOOSING_YOUR_DOG}`,
						progress: surveyProgress.CHOOSING_YOUR_DOG,
					},
					{
						routeName: "UNDERSTANDING_YOUR_DOG",
						label: `Your progress for Understanding your dog is ${surveyProgress.UNDERSTANDING_YOUR_DOG}`,
						progress: surveyProgress.UNDERSTANDING_YOUR_DOG,
					},
					{
						routeName: "RELATIONSHIP_WITH_YOUR_DOG",
						label: `Your progress for Relationship with your dog is ${surveyProgress.RELATIONSHIP_WITH_YOUR_DOG}`,
						progress: surveyProgress.RELATIONSHIP_WITH_YOUR_DOG,
					},
					{
						routeName: "ABOUT_YOU",
						label: `Your progress for About you is ${surveyProgress.ABOUT_YOU}`,
						progress: surveyProgress.ABOUT_YOU,
					},
				];
	}, [surveyProgress]);

	return (
		<>
			{surveyProgressSegments.map(({ routeName, label, progress }) => (
				<NDSSurveyProgressSegment
					key={routeName}
					route={routeName}
					label={label}
					progress={progress}
				/>
			))}
		</>
	);
};
interface NDSSurveyProgressSegmentProps {
	route: NDS.RouteName;
	label: string;
	progress: number;
}

export const NDSSurveyProgressSegment: React.FC<
	NDSSurveyProgressSegmentProps
> = ({ label, progress, route }) => {
	const {
		surveyState: { surveyProgress },
		screenState: { route: currentRoute },
	} = useNationalDogSurveyContext();

	const multiDogSection = useMemo(() => {
		if (currentRoute !== "SUBSEQUENT_DOG") {
			return null;
		}
		if ("THOUGHTS_ON_DOGS" in surveyProgress) {
			return null;
		}
		if (!surveyProgress.SUBSEQUENT_DOG) {
			return null;
		}
		if (surveyProgress.SUBSEQUENT_DOG.ABOUT_YOUR_DOGS < 100) {
			return "ABOUT_YOUR_DOGS";
		}
		if (surveyProgress.SUBSEQUENT_DOG.CHOOSING_YOUR_DOG < 100) {
			return "CHOOSING_YOUR_DOG";
		}
		if (surveyProgress.SUBSEQUENT_DOG.UNDERSTANDING_YOUR_DOG < 100) {
			return "UNDERSTANDING_YOUR_DOG";
		}
		return null;
	}, [currentRoute, surveyProgress]);

	return (
		<div className={styles.sectionProgressBar}>
			<span className={styles.progressBar} aria-hidden />
			<span
				role="status"
				aria-live="polite"
				aria-label={label}
				className={styles.progressStatus}
				style={{
					width: `${Math.max(progress, 0)}%`,
				}}
			/>

			{/* This is the main dog animation it only shows when the multi-dog route is not active */}
			{route !== "SUBSEQUENT_DOG" && currentRoute === route && (
				<Lottie
					key={"lottie-main-dog"}
					style={{
						marginInlineStart: `calc(${progress}%`,
					}}
					className={styles.lottieAnimation}
					animationData={dogProgress}
					loop={true}
				/>
			)}
			{currentRoute === "SUBSEQUENT_DOG" && route === "ABOUT_YOU" && (
				<Lottie
					key={"lottie-main-dog-sitting"}
					className={styles.lottieAnimationSitting}
					style={{
						marginInlineStart: `calc(${90}%`,
						width: "var(--s-7)",
						transform: "scaleX(-1)",
					}}
					animationData={dogProgressSit}
					loop={true}
				/>
			)}
			{"SUBSEQUENT_DOG" in surveyProgress &&
				currentRoute === "SUBSEQUENT_DOG" &&
				route === multiDogSection && (
					<Lottie
						key={`lottie-multi-dog-${label}`}
						style={{
							marginInlineStart: `calc(${surveyProgress.SUBSEQUENT_DOG[multiDogSection]}% - 20px)`,
						}}
						className={styles.lottieAnimation}
						animationData={dogProgress}
						loop={true}
					/>
				)}
		</div>
	);
};

/**

 {progressIndex === 4 && mainDogPosition === 4 && (
	<Lottie
		key={"lottie-main-dog-sitting"}
		className={styles.lottieAnimationSitting}
		style={{
			marginInlineStart: `calc(${90}%`,
			transform: "scaleX(-1)",
		}}
		animationData={ndsLottieMap.WalkCycleSitAnimation}
		loop={true}
	/>
)}


{multiDogPosition?.[0] === progressIndex && (
	<Lottie
		key={`lottie-multi-dog-${label}`}
		style={{
			marginInlineStart: `calc(${multiDogPosition[1]}% - 20px)`,
		}}
		className={styles.lottieAnimation}
		animationData={ndsLottieMap.WalkCycleAnimation}
		loop={true}
	/>
)}
</div>
 */
